import { Organization } from 'constants/interface';
import { useMemo } from 'react';
import { userPermissionsSelector } from 'state/slices/session';
import { useSelector } from './store';

export const useUserOrganizations = (): Organization[] => {
  const userPermissions = useSelector(userPermissionsSelector);
  const organizations = useMemo(() => (
    userPermissions?.map((perm) => perm.organization) || []
  ), [userPermissions]);

  return organizations;
};
